function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212A33",
  fillRule: "evenodd",
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m.5 3a.81.81 0 0 0-.724.447L6 7v3l.165.154c.62.544 1.42.846 2.25.846h1.23a2 2 0 0 0 1.858-1.257l.948-2.372A1 1 0 0 0 11.523 6H9V3.5a.5.5 0 0 0-.5-.5M4 6a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/badges/ic-badge-like.svg";
export { SvgComponent as ReactComponent };